export default __webpack_public_path__ + "static/media/component-profile-card.52a3ee76.png";